import type { StoreType } from '.';

export const selectSchoolTypes = (state: StoreType) => state.schoolTypes.data || [];

export const selectSchoolTypesLoadingStatus = (state: StoreType) => state.schoolTypes.status;
